import DoAPICall from "./DoAPICall";

// Create promotion ('C' in CRUD)
export async function createPromotion(userToken, promotion) {
  const apiPayload = {
    httpMethod: "post",
    userToken,
    uri: "promotions",
    payLoad: {
      client_id: promotion.client_id,
      name: promotion.name,
      description: promotion.description,
      consumerType:promotion.consumerType,
      entryAmount: promotion.entryAmount,
      raffleEntryAmount:promotion.raffleEntryAmount,
      onDebt: promotion.onDebt,
      type: promotion.type,
      resetMonthly: promotion.resetMonthly,
      rateValue: promotion.rateValue,
      startDate: promotion.startDate,
      endDate: promotion.endDate,
      status: promotion.status,
    },
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Get all promotions ('R' in CRUD)
export async function getPromotions(userToken) {
  const apiPayload = {
    httpMethod: "get",
    userToken,
    uri: "promotions",
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Get one promotion by ID ('R' in CRUD)
export async function getPromotion(userToken, id) {
  const apiPayload = {
    httpMethod: "get",
    userToken,
    uri: "promotions/" + id,
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Update promotion ('U' in CRUD)
export async function updatePromotion(userToken, promotion) {
  const apiPayload = {
    httpMethod: "put",
    userToken,
    uri: "promotions/" + promotion.id,
    payLoad: {
      client_id: promotion.client_id,
      name: promotion.name,
      description: promotion.description,
      consumerType:promotion.consumerType,
      entryAmount: promotion.entryAmount,
      raffleEntryAmount:promotion.raffleEntryAmount,
      onDebt: promotion.onDebt,
      type: promotion.type,
      resetMonthly: promotion.resetMonthly,
      rateValue: promotion.rateValue,
      startDate: promotion.startDate,
      endDate: promotion.endDate,
      status: promotion.status,
    },
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Delete promotion ('D' in CRUD)
export async function deletePromotion(userToken, id) {
  const apiPayload = {
    httpMethod: "delete",
    userToken,
    uri: "promotions/" + id,
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}
